<template>
    <div class="author-registration-container">
      <div class="page-header">
        <h2>Pendaftaran Penulis</h2>
        <p class="subtitle">Bagikan karyamu dan temukan pembaca dari seluruh Indonesia</p>
      </div>
      
      <div class="content-area">
        <div class="benefits-panel">
          <h3>Mengapa menjadi penulis di HobiBaca?</h3>
          <ul class="benefits-list">
            <li>
              <font-awesome-icon :icon="['fas', 'users']" class="benefit-icon" />
              <div>
                <h4>Raih Audiens Lebih Luas</h4>
                <p>Temukan ribuan pembaca potensial untuk karya Anda di platform kami</p>
              </div>
            </li>
            <li>
              <font-awesome-icon :icon="['fas', 'money-bill-wave']" class="benefit-icon" />
              <div>
                <h4>Dapatkan Penghasilan</h4>
                <p>Terima royalti berdasarkan jumlah pembaca dan langganan</p>
              </div>
            </li>
            <li>
              <font-awesome-icon :icon="['fas', 'chart-line']" class="benefit-icon" />
              <div>
                <h4>Pantau Performa</h4>
                <p>Dapatkan analisis terperinci tentang siapa pembaca Anda</p>
              </div>
            </li>
            <li>
              <font-awesome-icon :icon="['fas', 'laptop']" class="benefit-icon" />
              <div>
                <h4>Alat Penulisan yang Lengkap</h4>
                <p>Gunakan editor kami yang mudah digunakan dan fitur pengelolaan konten</p>
              </div>
            </li>
            <li>
              <font-awesome-icon :icon="['fas', 'copyright']" class="benefit-icon" />
              <div>
                <h4>Perlindungan Karya</h4>
                <p>Karya Anda dilindungi dan aman dari pembajakan</p>
              </div>
            </li>
          </ul>
        </div>
        
        <div class="registration-form-panel">
          <AuthorRegistrationForm @register-success="handleRegistrationSuccess" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import AuthorRegistrationForm from '@/components/AuthorRegistrationForm.vue';
  import { useHead } from '@unhead/vue';
  
  export default {
    name: 'AuthorRegistration',
    components: {
      AuthorRegistrationForm
    },
    setup() {
      useHead({
        title: 'Daftar Sebagai Penulis | HobiBaca',
        meta: [
          {
            name: 'description',
            content: 'Bergabunglah sebagai penulis di HobiBaca. Bagikan karya Anda dan raih pembaca di seluruh Indonesia.'
          },
          {
            name: 'keywords',
            content: 'penulis HobiBaca, daftar penulis, publikasi karya, menulis buku online, platform penulis Indonesia'
          },
          {
            property: 'og:title',
            content: 'Daftar Sebagai Penulis | HobiBaca'
          },
          {
            property: 'og:description',
            content: 'Bergabunglah sebagai penulis di HobiBaca. Bagikan karya Anda dan raih pembaca di seluruh Indonesia.'
          },
          {
            property: 'og:type',
            content: 'website'
          },
          {
            property: 'og:url',
            content: window.location.href
          }
        ]
      });
    },
    methods: {
      handleRegistrationSuccess() {
        // Additional logic if needed beyond what's in the form component
      }
    }
  };
  </script>
  
  <style scoped>
  .author-registration-container {
    max-width: 1200px;
    margin: 40px auto;
    padding: 0 20px;
  }
  
  .page-header {
    text-align: center;
    margin-bottom: 40px;
  }
  
  .page-header h2 {
    font-size: 36px;
    color: #333;
    margin-bottom: 10px;
  }
  
  .subtitle {
    font-size: 18px;
    color: #666;
  }
  
  .content-area {
    display: flex;
    gap: 40px;
    align-items: flex-start;
  }
  
  .benefits-panel {
    flex: 1;
    background-color: #f9fffc;
    border-radius: 8px;
    padding: 30px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  
  .benefits-panel h3 {
    color: #333;
    font-size: 22px;
    margin-bottom: 20px;
    text-align: center;
  }
  
  .benefits-list {
    list-style: none;
    padding: 0;
  }
  
  .benefits-list li {
    display: flex;
    margin-bottom: 20px;
    align-items: flex-start;
  }
  
  .benefit-icon {
    color: #488e71;
    font-size: 24px;
    margin-right: 15px;
    margin-top: 5px;
  }
  
  .benefits-list h4 {
    margin: 0 0 5px 0;
    color: #333;
    font-size: 18px;
  }
  
  .benefits-list p {
    margin: 0;
    color: #666;
    line-height: 1.5;
  }
  
  .registration-form-panel {
    flex: 1;
  }
  
  /* Responsive design */
  @media (max-width: 1024px) {
    .content-area {
      flex-direction: column;
    }
    
    .benefits-panel, .registration-form-panel {
      width: 100%;
    }
  }
  
  @media (max-width: 768px) {
    .page-header h2 {
      font-size: 28px;
    }
    
    .subtitle {
      font-size: 16px;
    }
    
    .benefits-panel {
      padding: 20px;
    }
  }
  </style>